
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/categories",
      function () {
        return require("private-next-pages/[region]/categories/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/categories"])
      });
    }
  